import { ILeagues, Leagues } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { LeaguesQuery } from "./types";

import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<LeaguesQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<LeaguesQuery>): ILeagues => {
  return transformer(props);
}

const LeaguesWidget = ({
  props,
  ...rest
}: WidgetContext<ILeagues>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
        <Leagues {...props} />
    </div>
  );
}

export default LeaguesWidget;